import React from 'react';
import { Navigate } from 'react-router-dom';

import { LOCATION } from '../constants/location';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error) {
    this.setState({
      error,
    });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <Navigate
          to={{
            pathname: LOCATION.ERROR,
          }}
        />
      );
    }

    return children;
  }
}
